/**
 * The early access form on the website (strategy: Teamna early access, 2026-11-01). Shared by the
 * API (validation, the Slack post), the website (the options) and Control Center (the list).
 */

/** "About how many members does the business have?" */
export const memberCounts = ["under_50", "50_150", "150_400", "over_400"] as const;
export type MemberCount = (typeof memberCounts)[number];

export const memberCountLabels: Record<MemberCount, string> = {
  under_50: "Under 50",
  "50_150": "50 to 150",
  "150_400": "150 to 400",
  over_400: "More than 400",
};

/** The label of a stored value. An unknown value shows as it is. */
export function memberCountLabel(value: string): string {
  return (memberCountLabels as Record<string, string>)[value] ?? value;
}
